import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { updateDocumentVersion } from "@/api/customerCenter/customerCenter";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import util from '@/libs/util';
import axios from 'axios';
export default {
  name: "modifyVersion",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      dialog: false,
      fileList: [],
      paramsData: {
        doc_type: '',
        version: '',
        title: '',
        env: '',
        server_id: '',
        doc_id: '',
        source_id: '',
        source_type: '',
        game: ''
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data) {
                  _context.next = 23;
                  break;
                }

                _this.getServer();

                _this.paramsData.doc_type = data.doc_type;
                _this.paramsData.title = data.title;
                _this.paramsData.version = data.version;
                _this.paramsData.doc_id = data.doc_id;
                _this.paramsData.env = data.env;
                _this.paramsData.server_id = Number(data.server_id);
                _this.paramsData.source_id = data.source_id;
                _this.paramsData.source_type = data.source_type; //this.paramsData = {...data}

                if (!(_this.rawData.game_mark.indexOf('yjfm') == -1)) {
                  _context.next = 14;
                  break;
                }

                _this.paramsData.is_prod = _this.severlist.length ? _this.severlist[0].value : '';
                _context.next = 23;
                break;

              case 14:
                if (!_this.szgmEnv.length) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _this.szgmEnv[0].id;

              case 17:
                _context.t0 = _context.sent;
                _context.next = 21;
                break;

              case 20:
                _context.t0 = '';

              case 21:
                _this.paramsData.env_id = _context.t0;
                _this.paramsData.game_id = _this.rawData.game_id;

              case 23:
                _this.dialog = true;

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getServer: function getServer() {
      var _this2 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this2.serverList = res.data;
        }
      });
    },
    resetForm: function resetForm() {
      this.dialog = false;
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this3.paramsData));
          data.special_product_id = _this3.searchData.special_product_id || '';
          data.server_id = String(data.server_id);
          updateDocumentVersion(_objectSpread({}, data)).then(function (res) {
            if (res.status == 'succeeded') {
              _this3.resetForm();

              _this3.$message({
                message: '操作成功',
                type: 'success'
              });

              _this3.$emit('change');
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.paramsData = {
        type: '',
        version: '',
        title: '',
        description: '',
        server_id: '',
        file: null,
        text_content: '',
        doc_type: ''
      };
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    }
  }
};